module.exports = __webpack_public_path__ + "img/michelle-avaroma.b49249ba.jpg";